import yup from '@/init/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { InferType } from 'yup';

export const SearchStationNameSchema = yup.object({
  portal_office_name: yup.string().required('必須です'),
  sort_by: yup.string(),
});

export type SearchStationNameType = InferType<typeof SearchStationNameSchema>;
export const SearchStationNameResolver = yupResolver(SearchStationNameSchema);
